import Navbar from "../components/navbar";
import FeaturesTwo from "../components/features-two";
import Screenshot from "../components/screenshot";
import Faq from "../components/faq";
import Contact from "../components/contact";
import Footer from "../components/footer";
import HeroSection from "../components/hero-section";
import { useTranslation } from "react-i18next";
import PremiumPerks from "../components/premium_perks";

export default function IndexFour() {
  const { t } = useTranslation();
  return (
    <>
      <Navbar navLight={false} playBtn={true} bgLight={true} navCenter={true} />

      <HeroSection />

      <section
        className="relative md:py-24 py-16 bg-primaryFaint"
        id="features"
      >
        <div className="container relative">
          <div className="grid grid-cols-1 pb-6 text-center">
            <h6 className="text-primaryColor uppercase text-sm font-bold tracking-wider mb-3">
              {t("features.title")}
            </h6>
            <h4 className="mb-6 md:text-3xl text-2xl md:leading-normal leading-normal font-bold">
              {t("features.subtitle")}
            </h4>

            <p className="text-slate-400 max-w-xl mx-auto">
              {t("features.description")}
            </p>
          </div>

          <FeaturesTwo />
        </div>
        <div className="container relative md:mt-24 mt-16">
          <PremiumPerks />
        </div>
      </section>

      <section
        className="relative md:py-24 py-16 dark:bg-slate-800/20"
        id="screenshot"
      >
        <div className="container relative">
          <div className="grid grid-cols-1 pb-6 text-center">
            <h6 className="text-primaryColor uppercase text-sm font-bold tracking-wider mb-3">
              {t("screenshots.title")}
            </h6>
            <h4 className="mb-6 md:text-3xl text-2xl md:leading-normal leading-normal font-bold">
              {t("screenshots.subtitle")}
            </h4>

            <p className="text-slate-400 max-w-xl mx-auto">
              {t("screenshots.description")}
            </p>
          </div>

          <Screenshot />
        </div>
      </section>

      <section
        className="relative overflow-hidden md:py-24 py-16 bg-primaryFaint"
        id="faqs"
      >
        <Faq />
      </section>

      <section className="relative md:py-24 py-16" id="contact">
        <Contact />
      </section>

      <Footer />
    </>
  );
}
